module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBigBlack.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBigBlack.svg
// module id = 249
// module chunks = 0